import { shouldUseEventDesignDraft as checkForEventDesignDraft } from '@shared/utils/eventDesignPurpose';
import { withWindow } from '@shared/utils/withWindow';

export const shouldUseEventDesignDraft = () =>
  withWindow<boolean>(window => {
    const src = window.frameElement?.getAttribute('src');
    if (src) {
      return checkForEventDesignDraft();
    }
    return false;
  }, false);
